import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { comptabiliteApi } from '../../services/comptabiliteApi';
import { formatCurrency } from '../../utils/formatters';

const num = (s: string | number | null | undefined) => Number(s ?? 0);

const CLASSES: Record<number, string> = {
  1: 'Classe 1 — Ressources durables',
  2: 'Classe 2 — Actif immobilisé',
  3: 'Classe 3 — Stocks',
  4: 'Classe 4 — Tiers',
  5: 'Classe 5 — Trésorerie',
  6: 'Classe 6 — Charges',
  7: 'Classe 7 — Produits',
};

const PlanComptable: React.FC = () => {
  const { data: comptes = [], isLoading } = useQuery({
    queryKey: ['compta', 'comptes'],
    queryFn: () => comptabiliteApi.getComptes(),
  });

  if (isLoading) return <div className="p-6 text-gray-500">Chargement du plan comptable…</div>;

  const parClasse = comptes.reduce<Record<number, typeof comptes>>((acc, c) => {
    (acc[c.classe] = acc[c.classe] || []).push(c);
    return acc;
  }, {});

  return (
    <div className="w-full space-y-5">
      {Object.keys(parClasse).map((k) => {
        const classe = Number(k);
        return (
          <div key={k} className="bg-white rounded-xl shadow-sm overflow-hidden">
            <div className="px-4 py-3 border-b border-gray-100 bg-gray-50">
              <h3 className="font-semibold text-gray-800">{CLASSES[classe] || `Classe ${classe}`}</h3>
            </div>
            <table className="min-w-full divide-y divide-gray-100">
              <tbody className="divide-y divide-gray-50">
                {parClasse[classe].map((c) => (
                  <tr key={c.id} className="hover:bg-gray-50">
                    <td className="px-4 py-2 text-sm font-mono text-gray-500 w-24">{c.numero}</td>
                    <td className="px-4 py-2 text-sm text-gray-800">{c.intitule}</td>
                    <td className="px-4 py-2 text-xs text-gray-400 w-24">{c.type_compte_display}</td>
                    <td className="px-4 py-2 text-sm text-right font-medium text-gray-700 w-40">
                      {formatCurrency(num(c.solde))}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
};

export default PlanComptable;
